<template>
  <div class="LKBanners">
    <v-expand-transition>
      <LKBannersHeader
        v-if="list.length > 0"
        :active="active"
        :count="list.length"
        :new-count="newCount"
        :current="currentIndex + 1"
        :dots="list.length > 8"
        :label="label"
        :navigation="active && list.length !== listActive.length"
        class="LKBanners__header"
        @update:active="$emit('update:active', $event, listActive)"
        @prev="onChangeCurrent(-1)"
        @next="onChangeCurrent(+1)"
      />
    </v-expand-transition>

    <LKToggleContainer :active="active">
      <transition :name="direction < 0 ? 'slide-left' : 'slide-right'" mode="out-in">
        <div :key="currentIndex" class="LKBanners__list">
          <template v-for="item in listActive">
            <div :key="item.id" class="LKBanners__item">
              <LKBannersItem :data="item" />
            </div>
          </template>
        </div>
      </transition>
    </LKToggleContainer>
  </div>
</template>

<script>

import LKToggleContainer from '@/components/lk/LKToggleContainer.vue'
import LKBannersHeader from './LKBanners/LKBannersHeader.vue'
import LKBannersItem from './LKBanners/LKBannersItem.vue'


export default {
  name: 'LKBanners',
  components: {
    LKToggleContainer,
    LKBannersHeader,
    LKBannersItem,
  },
  props: {
    active: Boolean,
    list: {
      type: Array,
      required: true,
    },
    newCount: Number,
  },
  data: () => ({
    currentIndex: 0,
    direction: 1,
  }),
  computed: {
    label() {
      return this.active ? 'Скрыть новости' : 'Показать новости'
    },
    countPerLine() {
      return this.$vuetify.breakpoint.mdAndUp ? 2 : 1
    },
    listActive() {
      const index = this.currentIndex
      return this.list.slice(index, index + this.countPerLine)
    },
  },
  watch: {
    list() {
      this.currentIndex = 0
    },
  },
  methods: {
    onChangeCurrent(direction) {
      const { length } = this.list
      let currentIndex = this.currentIndex + direction

      if (currentIndex < 0) {
        currentIndex = length - 1
      }

      if (currentIndex >= length) {
        currentIndex = 0
      }

      this.currentIndex = currentIndex
      this.direction = direction

      this.$emit('update:viewed', this.listActive)
    },
  },
}
</script>

<style lang="scss" src="@/assets/scss/transitions/transition-slide.scss"></style>

<style lang="scss">
.LKBanners {
  &__header {
    margin-bottom: 20px;
  }

  &__list {
    display: flex;
  }

  &__item {
    flex-shrink: 0;
    width: 100%;
    margin-bottom: 20px;

    @media screen and (min-width: 992px) {
      width: calc(50% - 15px);

      & + & {
        margin-left: 30px;
      }
    }
  }
}
</style>
